import type { ReactNode } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useHeaderAction } from "../../../core/provider/HeaderActionProvider/HeaderAction.js";

interface AuthLayoutProps {
    children?: ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
    const { action } = useHeaderAction();
    const { pathname } = useLocation();

    // ✅ برای /select-role پدینگ نده
    const isSelectRole = pathname === "/login";

    return (
        <div className="w-full max-w-[450px] 3xl:max-w-[504px] h-dvh bg-gray-200 shadow-2xl overflow-hidden relative flex flex-col rounded-none md:rounded-t-none border-0 md:border border-gray-200 mx-auto">
            {action && (
                <header className="h-14 border-gray-100 flex items-center px-4 shrink-0 z-20">
                    <div className="flex-1">
                        {action}
                    </div>
                </header>
            )}

            <main className="flex-1 min-h-0 rounded-t- overflow-y-auto no-scrollbar bg-white scroll-smooth">
                <div className={`w-full h-full ${isSelectRole ? "" : "p-2"}`}>
                    <Outlet />
                </div>
            </main>
        </div>
    );
}